import {
  UNLOCKACCOUNT_SUCCESS,
  UNLOCKACCOUNT_FAILED,
  RESET_UNLOCKACCOUNT,
  LOADING_UNLOCKACCOUNT,
  NETWORK_ERROR_UNLOCKACCOUNT,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetManualDepositList = () => {
  return { type: RESET_UNLOCKACCOUNT };
};

const unLockAccount = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_UNLOCKACCOUNT });
  await partnerServices
    .post("unLockAccount", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.status) {
        case 200:
          dispatch(getUnLockAccountsuccess(res.data));
          break;
        default:
          dispatch(getUnLockAccountFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_UNLOCKACCOUNT, payload: err });
    });
};
function getUnLockAccountsuccess(data) {
  return {
    type: UNLOCKACCOUNT_SUCCESS,
    payload: data,
  };
}
function getUnLockAccountFailed(data) {
  return {
    type: UNLOCKACCOUNT_FAILED,
    payload: data,
  };
}

export { resetGetManualDepositList, unLockAccount };
